//#region src/untrailingSlashIt.ts
/**
* Removes a trailing / from a string
*
* @category Strings
* @example
* ```ts twoslash
* import { untrailingSlashIt } from '@simplisafe/ewok'
*
* untrailingSlashIt('abc/') // => 'abc'
* ```
*/
function untrailingSlashIt(s) {
	return s.replace(/\/+$/, "");
}

//#endregion
export { untrailingSlashIt };